__turbopack_context__.v({
  "linksContainer": "TermsAndPrivacyLinks-module-scss-module__2QTUya__linksContainer",
});
